"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 74759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48512);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69224);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96756);


const ErrorBox = (param)=>{
    let { isLoading , onRetry , heading  } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        p: 4,
        textAlign: "center",
        bg: "red.100",
        borderRadius: "xl",
        color: "red.600",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                mb: 2,
                children: heading
            }),
            onRetry && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                isLoading: isLoading,
                onClick: onRetry,
                children: "Retry"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorBox);


/***/ }),

/***/ 95484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Leaderboard_Leaderboard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(80883);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(542);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 4 modules
var button_button = __webpack_require__(96756);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-auth@4.24.11_next@12.3.7_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react@1_acaee22c3ffd625475c47b7b2c959a5f/node_modules/next-auth/react/index.js
var react = __webpack_require__(25096);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var node_modules_react = __webpack_require__(75271);
// EXTERNAL MODULE: ./src/components/shared/ErrorBox/ErrorBox.tsx
var ErrorBox = __webpack_require__(74759);
// EXTERNAL MODULE: ./src/components/shared/Skeleton/index.ts + 1 modules
var Skeleton = __webpack_require__(73780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./src/components/shared/Medal/index.ts + 3 modules
var Medal = __webpack_require__(41923);
// EXTERNAL MODULE: ./src/components/shared/Motion/index.tsx
var Motion = __webpack_require__(47474);
// EXTERNAL MODULE: ./src/components/shared/PlayerAvatar/index.ts + 1 modules
var PlayerAvatar = __webpack_require__(81228);
// EXTERNAL MODULE: ./src/components/shared/PlayerName/index.ts + 1 modules
var PlayerName = __webpack_require__(72869);
// EXTERNAL MODULE: ./src/components/shared/PointIcon/index.ts + 1 modules
var PointIcon = __webpack_require__(60135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/system/system.mjs + 4 modules
var system = __webpack_require__(18645);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/badge/badge.mjs
var badge = __webpack_require__(74352);
;// CONCATENATED MODULE: ./src/components/shared/Leaderboard/PositionNumber.tsx


const PositionNumber = (param)=>{
    let { position  } = param;
    const digits = Math.max(position.toString().length, 2);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
        textAlign: "right",
        w: "2.5rem",
        pr: 2,
        fontSize: "".concat(1.875 / (0.5 * (digits - 2) + 1), "rem"),
        color: "grey.9",
        whiteSpace: "nowrap",
        overflow: "hidden",
        sx: {
            fontVariantNumeric: "tabular-nums"
        },
        letterSpacing: "tighter",
        userSelect: "none",
        children: position
    });
};
/* harmony default export */ var Leaderboard_PositionNumber = (PositionNumber);

;// CONCATENATED MODULE: ./src/components/shared/Leaderboard/LeaderboardPosition.tsx











const FirstPlaceFx = (0,system/* styled */.z)(box/* Box */.x, {
    baseStyle: {
        background: "linear-gradient(-30deg, #14ffe9, #ffeb3b, #fe33a1)",
        inset: 1,
        position: "absolute",
        borderRadius: "xl",
        filter: "blur(12px)",
        opacity: 1,
        isolation: "isolate",
        transform: "translateZ(-1)"
    }
});
const LeaderboardPosition = (_param)=>{
    var { user , isMe =false , bottom , bg  } = _param, chakraProps = (0,_object_without_properties/* default */.Z)(_param, [
        "user",
        "isMe",
        "bottom",
        "bg"
    ]);
    var ref;
    const isFirstPlace = user.position === 1;
    const meProps = isMe && typeof bottom !== "undefined" ? {
        pos: "sticky",
        bottom: bottom,
        zIndex: "docked",
        _before: {
            zIndex: "-1",
            content: "''",
            position: "absolute",
            inset: "-.5rem",
            bg,
            maskImage: "linear-gradient(to bottom, rgba(0,0,0,0) , rgba(0,0,0,1) 33%) "
        }
    } : {};
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Motion/* MotionHStack */.$, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        layout: true
    }, chakraProps, meProps), {
        children: [
            !isFirstPlace && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_PositionNumber, {
                position: user.position
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                position: "relative",
                w: "100%",
                children: [
                    isFirstPlace && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FirstPlaceFx, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                        bg: "grey.1",
                        p: {
                            base: 2,
                            sm: isFirstPlace ? 4 : 3
                        },
                        borderRadius: "xl",
                        gap: 2,
                        position: "relative",
                        boxShadow: isFirstPlace ? "0 32px 64px 0 rgba(0,0,0,0.1)" : undefined,
                        zIndex: isFirstPlace ? 1 : undefined,
                        border: "1px solid transparent",
                        borderColor: isMe ? "primary.9" : undefined,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerAvatar/* default */.Z, {
                                user: user,
                                size: isFirstPlace ? 16 : 10,
                                isLink: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
                                flexGrow: 1,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerName/* default */.Z, {
                                                fontWeight: isFirstPlace ? "bold" : "medium",
                                                letterSpacing: "tight",
                                                user: user,
                                                noOfLines: 1,
                                                py: 1,
                                                isLink: true
                                            }),
                                            " ",
                                            ((ref = user.boast) === null || ref === void 0 ? void 0 : ref.id) && user.boast.seasonid && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Medal/* default */.Z, {
                                                id: user.boast.id,
                                                seasonId: user.boast.seasonid
                                            }),
                                            isMe && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(badge/* Badge */.C, {
                                                variant: "solid",
                                                colorScheme: "primary",
                                                children: "You"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                                        fontSize: "sm",
                                        color: "grey.9",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography_text/* Text */.x, {
                                                children: [
                                                    user.wins,
                                                    " wins"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography_text/* Text */.x, {
                                                children: [
                                                    user.losses,
                                                    " losses"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(badge/* Badge */.C, {
                                fontWeight: "medium",
                                variant: "subtle",
                                css: {
                                    fontVariantNumeric: "tabular-nums"
                                },
                                children: [
                                    user.points,
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointIcon/* default */.Z, {
                                        ml: 0.5
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Leaderboard_LeaderboardPosition = (LeaderboardPosition);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(75616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(21617);
;// CONCATENATED MODULE: ./src/components/shared/Leaderboard/useLeaderboard.tsx




const useLeaderboard = (options)=>{
    const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    const queryKey = (0,node_modules_react.useMemo)(()=>{
        return [
            "leaderboard",
            options
        ];
    }, [
        options
    ]);
    const invalidate = ()=>queryClient.invalidateQueries(queryKey);
    const query = (0,useInfiniteQuery/* useInfiniteQuery */.N)(queryKey, async (param)=>{
        let { pageParam =1  } = param;
        const searchParams = new URLSearchParams(JSON.parse(JSON.stringify(options)));
        searchParams.set("perPage", "20");
        pageParam && searchParams.set("page", pageParam);
        const res = await fetch([
            "/api/leaderboard",
            searchParams.toString()
        ].join("?")).then((res)=>res.json());
        return res;
    }, {
        refetchInterval: 1000 * 60,
        getNextPageParam: (lastPage)=>{
            var ref;
            return lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.pageInfo) === null || ref === void 0 ? void 0 : ref.nextPage;
        }
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        invalidate
    });
};
/* harmony default export */ var Leaderboard_useLeaderboard = (useLeaderboard);

;// CONCATENATED MODULE: ./src/components/shared/Leaderboard/Leaderboard.tsx










const Leaderboard = (param)=>{
    let { gameId , seasonId , stickyMe , bg , offsetPlayerBottom  } = param;
    const { data: session  } = (0,react.useSession)();
    const { data , hasNextPage , fetchNextPage , status , invalidate , fetchStatus  } = Leaderboard_useLeaderboard({
        gameId,
        seasonId
    });
    const loadMoreRef = (0,node_modules_react.useRef)(null);
    (0,node_modules_react.useEffect)(()=>{
        const options = {
            root: null,
            rootMargin: "500px",
            threshold: 1
        };
        const handleObserver = (entities)=>{
            const target = entities[0];
            if (target.isIntersecting && hasNextPage) {
                fetchNextPage();
            }
        };
        const observer = new IntersectionObserver(handleObserver, options);
        if (hasNextPage && loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }
        return ()=>observer.disconnect();
    }, [
        hasNextPage,
        fetchNextPage
    ]);
    if (status === "error") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBox/* default */.Z, {
        heading: "Error loading leaderboard",
        onRetry: invalidate
    });
    if (status === "loading") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(stack/* Stack */.K, {
        children: new Array(10).fill(0).map((_, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(h_stack/* HStack */.U, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_PositionNumber, {
                        position: i + 1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                        w: "100%",
                        h: i === 0 ? "6.1rem" : "5rem",
                        borderRadius: "xl"
                    })
                ]
            }, i))
    });
    const allPositions = data.pages.flatMap((page)=>{
        var ref;
        return page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.positions;
    });
    if (allPositions && allPositions.length === 0) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
        textAlign: "center",
        color: "grey.10",
        py: 8,
        children: "No leaderboard available yet!"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(stack/* Stack */.K, {
        children: [
            allPositions === null || allPositions === void 0 ? void 0 : allPositions.map((player)=>{
                if (!player) return null;
                const isMe = (session === null || session === void 0 ? void 0 : session.user.id) === player.id;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_LeaderboardPosition, {
                    user: player,
                    isMe: isMe,
                    bottom: isMe && stickyMe ? offsetPlayerBottom || 0 : undefined,
                    bg: bg
                }, player.id);
            }),
            hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_button/* Button */.z, {
                ref: loadMoreRef,
                isLoading: fetchStatus === "fetching",
                variant: "subtle",
                colorScheme: "grey",
                onClick: ()=>fetchNextPage(),
                children: "Load more"
            }),
            !allPositions.find((position)=>{
                var ref;
                return (position === null || position === void 0 ? void 0 : position.id) === (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id);
            }) && (session === null || session === void 0 ? void 0 : session.user.id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayerPosition, {
                userId: session.user.id,
                bottom: stickyMe ? offsetPlayerBottom || 0 : undefined,
                gameId: gameId,
                seasonId: seasonId,
                bg: bg
            })
        ]
    });
};
const PlayerPosition = (_param)=>{
    var { bottom , bg  } = _param, ids = (0,_object_without_properties/* default */.Z)(_param, [
        "bottom",
        "bg"
    ]);
    var ref, ref1, ref2;
    const { data: playerPositions  } = Leaderboard_useLeaderboard(ids);
    const player = (ref1 = playerPositions === null || playerPositions === void 0 ? void 0 : (ref = playerPositions.pages) === null || ref === void 0 ? void 0 : ref[0].data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.positions) === null || ref2 === void 0 ? void 0 : ref2[0];
    if (!player) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Leaderboard_LeaderboardPosition, {
        user: player,
        bottom: bottom,
        isMe: true,
        bg: bg
    }, player.id);
};
/* harmony default export */ var Leaderboard_Leaderboard = (Leaderboard);

;// CONCATENATED MODULE: ./src/components/shared/Leaderboard/index.ts



/***/ }),

/***/ 41923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Medal_Medal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(48512);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.36.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/lib/fetcher.ts
var fetcher = __webpack_require__(51581);
;// CONCATENATED MODULE: ./src/lib/useSeasonMedals.ts


const useSeasonMedals = (seasonId)=>{
    return (0,useQuery/* useQuery */.a)([
        "medals",
        {
            seasonId
        }
    ], (0,fetcher/* createFetcher */.g)("/api/seasons/".concat(seasonId, "/medals")), {
        staleTime: Infinity
    });
};
/* harmony default export */ var lib_useSeasonMedals = (useSeasonMedals);

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(72893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/tooltip/tooltip.mjs + 4 modules
var tooltip = __webpack_require__(48353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+react@2.10.9_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@emot_2a5fdf7c628c94bdccf0335529e04f30/node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(69224);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(79277);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.14.0_@emotion+react@11.14.0_@types+react@18.0.21_react@18.3.1__@types+react@18.0.21_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(26091);
// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 166 modules
var motion = __webpack_require__(3276);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(75271);
;// CONCATENATED MODULE: ./src/components/shared/Medal/utils.ts
const getRelativeCoordinates = (event, referenceElement)=>{
    if (!referenceElement) return null;
    const position = {
        x: event.pageX,
        y: event.pageY
    };
    const offset = {
        left: referenceElement.offsetLeft,
        top: referenceElement.offsetTop,
        width: referenceElement.clientWidth,
        height: referenceElement.clientHeight
    };
    let reference = referenceElement.offsetParent;
    while(reference instanceof HTMLElement){
        offset.left += reference.offsetLeft;
        offset.top += reference.offsetTop;
        reference = reference.offsetParent;
    }
    return {
        x: position.x - offset.left,
        y: position.y - offset.top,
        width: offset.width,
        height: offset.height,
        centerX: (position.x - offset.left - offset.width / 2) / (offset.width / 2),
        centerY: (position.y - offset.top - offset.height / 2) / (offset.height / 2)
    };
};

;// CONCATENATED MODULE: ./src/components/shared/Medal/Medal.tsx
/* eslint-disable @next/next/no-img-element */ 







const shimmer = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("	0%{background-position:0% 0%;opacity:0}50%{background-position:50% 50%;opacity:.9}100%{background-position:86% 86%;opacity:0}", "shimmer");
const wrapperStyle = {
    w: "2em",
    h: "2em",
    display: "inline-block",
    position: "relative"
};
const MedalWrapper = (0,motion/* motion */.E)((0,emotion_styled_browser_esm/* default */.Z)(box/* Box */.x, {
    baseStyle: wrapperStyle
}));
const Medal = (param)=>{
    let { id , seasonId  } = param;
    var ref;
    const { data: res , error  } = lib_useSeasonMedals(seasonId);
    const { 0: mousePosition , 1: setMousePosition  } = (0,react.useState)(null);
    const boxRef = (0,react.useRef)(null);
    if (error || (res === null || res === void 0 ? void 0 : res.status) !== "ok") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        tabIndex: 0,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
            sx: wrapperStyle,
            color: "grey.6",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                viewBox: "0 0 308 308",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M140 8.0829C148.663 3.08118 159.337 3.08119 168 8.0829L273.368 68.9171C282.031 73.9188 287.368 83.1624 287.368 93.1658V214.834C287.368 224.838 282.031 234.081 273.368 239.083L168 299.917C159.337 304.919 148.663 304.919 140 299.917L34.6321 239.083C25.9688 234.081 20.6321 224.838 20.6321 214.834V93.1658C20.6321 83.1624 25.9689 73.9188 34.6321 68.9171L140 8.0829Z",
                    fill: "currentColor"
                })
            })
        })
    });
    const medal = (ref = res.data) === null || ref === void 0 ? void 0 : ref[id];
    const handleMouseMove = (e)=>{
        setMousePosition(getRelativeCoordinates(e, boxRef.current));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip/* Tooltip */.u, {
        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(box/* Box */.x, {
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                    children: medal === null || medal === void 0 ? void 0 : medal.description
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(typography_text/* Text */.x, {
                    fontWeight: "bold",
                    children: medal === null || medal === void 0 ? void 0 : medal.name
                })
            ]
        }),
        placement: "top",
        shouldWrapChildren: true,
        offset: [
            0,
            32
        ],
        variant: "medal",
        closeOnClick: false,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MedalWrapper, {
            css: {
                transformStyle: "preserve-3d"
            },
            ref: boxRef,
            onMouseMove: handleMouseMove,
            initial: {
                scale: 1
            },
            whileHover: mousePosition ? {
                transition: {
                    scale: {
                        delay: 0.25
                    },
                    default: {
                        delay: 0
                    }
                },
                zIndex: 2,
                scale: 2,
                rotateY: mousePosition.centerX * -20,
                rotateX: mousePosition.centerY * 20,
                filter: "brightness(".concat(1 + (-mousePosition.centerX - mousePosition.centerY) / (mousePosition.height + mousePosition.width) * 10, ")")
            } : {},
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                    as: "img",
                    position: "absolute",
                    inset: "0",
                    src: (medal === null || medal === void 0 ? void 0 : medal.url) || "/medals/default.svg",
                    alt: (medal === null || medal === void 0 ? void 0 : medal.name) || "Badge"
                }),
                (medal === null || medal === void 0 ? void 0 : medal.isHolographic) && medal.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(box/* Box */.x, {
                    role: "presentation",
                    position: "absolute",
                    inset: "0",
                    mixBlendMode: "hard-light",
                    css: {
                        maskImage: "url(".concat(medal.url.replace(".svg", "_holo.svg"), ")"),
                        maskSize: "contain"
                    },
                    background: "linear-gradient(-30deg,\n              rgba(255, 0, 0, 1),\n              rgba(255, 154, 0, 1),\n              rgba(208, 222, 33, 1),\n              rgba(79, 220, 74, 1),\n              rgba(63, 218, 216, 1),\n              rgba(47, 201, 226, 1),\n              rgba(28, 127, 238, 1),\n              rgba(95, 21, 242, 1),\n              rgba(186, 12, 248, 1),\n              rgba(251, 7, 217, 1),\n              rgba(255, 0, 0, 1)\n          )",
                    backgroundSize: "200% 200%",
                    "aria-hidden": true,
                    animation: "".concat(shimmer, " 2s linear infinite")
                })
            ]
        })
    });
};
/* harmony default export */ var Medal_Medal = (Medal);

;// CONCATENATED MODULE: ./src/components/shared/Medal/index.ts



/***/ }),

/***/ 47474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ MotionHStack; },
/* harmony export */   "u": function() { return /* binding */ MotionBox; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(542);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3276);


const MotionBox = (0,framer_motion__WEBPACK_IMPORTED_MODULE_0__/* .motion */ .E)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x);
const MotionHStack = (0,framer_motion__WEBPACK_IMPORTED_MODULE_0__/* .motion */ .E)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .U);



/***/ })

}]);